module.exports = __webpack_public_path__ + "8e480960dea4a7d60b3144ee3e1f7465.glb";